import { Reducer } from 'redux';
import { isType } from 'typescript-fsa';

import {
  createDefaultState,
  addEntityRecord,
  onGetAllSuccess,
  onStart,
  onCreateOrUpdate,
} from 'src/store/store.helpers';
import {
  EntityError,
  MappedEntityState2 as MappedEntityState,
} from 'src/store/types';
import {
  allCompletedLoanAppsRequest,
  updateMultipleCompletedLoanApps,
  allCompletedLoanAppsRequestSuccess,
  updateCompletedLoanApps,
  _updateCompletedAdvisorLoanAppsInStore,
} from './loanappsCompletedAdvisor.actions';
import { pathOr } from 'ramda';
import { ONE, ZERO_NUMBER } from 'src/services/constants';

/**
 * State
 */

export type State = MappedEntityState<any, EntityError>;

export const defaultState: State = createDefaultState();

/**
 * Reducer
 */
const reducer: Reducer<State> = (state = defaultState, action) => {
  if (isType(action, allCompletedLoanAppsRequest)) {
    return onStart(state);
  }

  if (isType(action, allCompletedLoanAppsRequestSuccess)) {
    const { result } = action.payload;
    return onGetAllSuccess(
      // since 1 is given as static because we have number_of_pages in 0,data will be in 1 index
      pathOr([], ['items', ONE], result),
      state,
      pathOr([], ['items', ZERO_NUMBER], result)
    );
  }

  if (isType(action, updateMultipleCompletedLoanApps)) {
    const { payload } = action;
    let updated = {};
    const items = pathOr([], ['items', ONE], payload);
    const results = pathOr(0, ['items', ZERO_NUMBER], payload);
    items.forEach((item) => {
      updated = addEntityRecord(updated, item);
    });
    return {
      ...state,
      itemsById: updated,
      results,
    };
  }
  if (isType(action, _updateCompletedAdvisorLoanAppsInStore)) {
    const { payload } = action;
    return onCreateOrUpdate(payload, state);
  }
  if (isType(action, updateCompletedLoanApps)) {
    const { payload } = action;
    let updated = {};
    const items = pathOr([], ['items', ONE], payload);
    const results = pathOr(0, ['items', ZERO_NUMBER], payload);
    items.forEach((item) => {
      updated = addEntityRecord(updated, item);
    });
    return {
      ...state,
      itemsById: updated,
      results,
    };
  }

  return state;
};

export default reducer;
